/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { ROUTES } from "../constants/constants";

export const navFeatureRegistry = [
  {
    key: "products",
    isEnabled: (navContext) => navContext.hasProductsForSale,
    buildNavItem: (navContext) => {
      const hasCategories = navContext.config?.product_use_categories && Array.isArray(navContext.categoriesData);
      return {
        label: "Products",
        route: hasCategories ? ROUTES.PRODUCTS_FOR_SALE_CATEGORIES : ROUTES.PRODUCTS_FOR_SALE,
        onBeforeNavigate: hasCategories ? navContext.resetCategory : undefined,
      };
    },
  },
  {
    key: "packages",
    isEnabled: (navContext) => navContext.hasPackages,
    buildNavItem: () => ({
      label: "Packages",
      route: ROUTES.PACKAGES,
    }),
  },
  {
    key: "memberships",
    isEnabled: (navContext) => navContext.hasMemberships,
    buildNavItem: () => ({
      label: "Memberships",
      route: ROUTES.MEMBERSHIPS,
    }),
  },
  {
    key: "giftCards",
    isEnabled: (navContext) => navContext.hasGiftCards,
    buildNavItem: () => ({
      label: "Gift cards",
      route: ROUTES.PROMOTIONS,
    }),
  },
];
